import{CombineLatestOperator as t}from"../observable/combineLatest.js";function e(e){return function(n){return n.lift(new t(e))}}export{e as combineAll};
